import { render } from "./EnDraggableWrapper.vue?vue&type=template&id=4d32db24"
import script from "./EnDraggableWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./EnDraggableWrapper.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/base/EnDraggableWrapper/EnDraggableWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d32db24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d32db24', __exports__)) {
    api.reload('4d32db24', __exports__)
  }
  
  module.hot.accept("./EnDraggableWrapper.vue?vue&type=template&id=4d32db24", () => {
    api.rerender('4d32db24', render)
  })

}


export default __exports__